import React from 'react';
import Events from '../events';

const view = 'scoping';
const eventsView = "testimonials";

function TAZAMATestimonials() {
  return <Events view={view} eventsView={eventsView} />
};

export default TAZAMATestimonials;
